import { combineReducers } from "redux";
import home from "./home";
import admin from "./admin";
import customer from "./customer";
import category from "./category";
import serviceProvider from "./serviceProvider";
import jobs from "./jobs";
import reports from "./reports";
import dataView from "./dataView";
import user from "./user";
import reviews from "./reviews";
import training from "./training";
import device from "./device";
import caching from "./caching";
import issueManagement from "./issueManagement/reducer";
import dataVisualization from "./dataVisualization/reducer";
import genbaAI from "./genbaAI";
import { isEqual } from "app/utils/javascript";
import { LOGOUT } from "./user/types";

const rootReducer = combineReducers({
    home,
    admin,
    caching,
    customer,
    category,
    serviceProvider,
    jobs,
    reports,
    dataView,
    dataVisualization,
    issueManagement,
    user,
    reviews,
    training,
    device,
    genbaAI,

});

const reducer = (state, action) => {
  if (isEqual(action.type, LOGOUT)) {
    state = undefined
  }
  return rootReducer(state, action)
}

export default reducer;
